import { StyleSheet, View, type ViewProps } from "react-native";

import { spacing } from "~/styles/theme";
import type { Space } from "./types";

export function Stack({
  gap = "md",
  align = "stretch",
  justify = "start",
  style,
  ...props
}: ViewProps & {
  gap?: Space;
  align?: "stretch" | "start" | "center" | "end";
  justify?: "start" | "center" | "end" | "between";
}) {
  return (
    <View
      style={[
        stylesByGap[gap],
        alignStyles[align],
        justifyStyles[justify],
        style,
      ]}
      {...props}
    />
  );
}

const stylesheet = StyleSheet.create({
  none: { gap: 0 },
  xs: { gap: spacing.xs },
  sm: { gap: spacing.s },
  md: { gap: spacing.m },
  lg: { gap: spacing.l },
  xl: { gap: spacing.xl },
  xxl: { gap: spacing.xxl },
  alignStretch: { alignItems: "stretch" },
  alignStart: { alignItems: "flex-start" },
  alignCenter: { alignItems: "center" },
  alignEnd: { alignItems: "flex-end" },
  justifyStart: { justifyContent: "flex-start" },
  justifyCenter: { justifyContent: "center" },
  justifyEnd: { justifyContent: "flex-end" },
  justifyBetween: { justifyContent: "space-between" },
});

const stylesByGap = {
  none: stylesheet.none,
  xs: stylesheet.xs,
  sm: stylesheet.sm,
  md: stylesheet.md,
  lg: stylesheet.lg,
  xl: stylesheet.xl,
  xxl: stylesheet.xxl,
};

const alignStyles = {
  stretch: stylesheet.alignStretch,
  start: stylesheet.alignStart,
  center: stylesheet.alignCenter,
  end: stylesheet.alignEnd,
};

const justifyStyles = {
  start: stylesheet.justifyStart,
  center: stylesheet.justifyCenter,
  end: stylesheet.justifyEnd,
  between: stylesheet.justifyBetween,
};
